import React from 'react';
import {
  FiAlertTriangle,
  FiPlus,
  FiEdit,
  FiTrash2,
  FiCalendar,
  FiUsers,
  FiUser,
  FiGrid,
  FiLogOut,
  FiMenu,
  FiX,
  FiMessageCircle,
  FiClock,
  FiCheck,
  FiStar,
  FiVideo,
  FiLink,
  FiExternalLink,
  FiCheckCircle,
  FiSearch,
  FiArrowRight,
  FiChevronLeft,
  FiChevronRight,
  FiChevronUp,
  FiChevronDown,
  FiList,
  FiMessageSquare,
  FiBarChart2,
  FiCheckSquare,
  FiSquare,
  FiCode,
  FiAward,
  FiSend,
  FiInfo,
  FiBold,
  FiItalic,
  FiUnderline,
  FiAlignLeft,
  FiAlignCenter,
  FiAlignRight,
  FiBook,
  FiFileText,
  FiImage,
  FiPaperclip,
  FiCopy
} from 'react-icons/fi';

const SafeIcon = ({ icon, name, ...props }) => {
  let IconComponent;
  const iconMap = {
    AlertTriangle: FiAlertTriangle,
    Plus: FiPlus,
    Edit: FiEdit,
    Trash2: FiTrash2,
    Calendar: FiCalendar,
    Users: FiUsers,
    User: FiUser,
    LayoutDashboard: FiGrid,
    LogOut: FiLogOut,
    Menu: FiMenu,
    X: FiX,
    MessageCircle: FiMessageCircle,
    Clock: FiClock,
    Check: FiCheck,
    Star: FiStar,
    Video: FiVideo,
    Link: FiLink,
    ExternalLink: FiExternalLink,
    CheckCircle: FiCheckCircle,
    Search: FiSearch,
    ArrowRight: FiArrowRight,
    ChevronLeft: FiChevronLeft,
    ChevronRight: FiChevronRight,
    ChevronUp: FiChevronUp,
    ChevronDown: FiChevronDown,
    List: FiList,
    MessageSquare: FiMessageSquare,
    BarChart2: FiBarChart2,
    CheckSquare: FiCheckSquare,
    Square: FiSquare,
    Code: FiCode,
    Award: FiAward,
    Send: FiSend,
    Info: FiInfo,
    Bold: FiBold,
    Italic: FiItalic,
    Underline: FiUnderline,
    AlignLeft: FiAlignLeft,
    AlignCenter: FiAlignCenter,
    AlignRight: FiAlignRight,
    Book: FiBook,
    FileText: FiFileText,
    Image: FiImage,
    Paperclip: FiPaperclip,
    Copy: FiCopy
  };

  if (icon) {
    IconComponent = icon;
  } else if (name && iconMap[name]) {
    IconComponent = iconMap[name];
  }

  return IconComponent ? React.createElement(IconComponent, props) : <FiAlertTriangle {...props} />;
};

export default SafeIcon;